export interface RuleParameterField {
  id: string;
  label: string;
  type: string;
}

export interface RuleParameterOption {
  label?: string;
  persistentName?: string | null;
  value?: string | number | null;
}

export type RuleParameterValues = Record<string, unknown>;

function isDropdownField(field: RuleParameterField) {
  return field.type === 'dropdown' || field.type === 'dropdown-dynamic';
}

function isEmptyValue(value: unknown) {
  return value === '' || value === null || value === undefined;
}

function isResolvedOption(value: unknown): value is RuleParameterOption {
  return Boolean(
    value && typeof value === 'object' && 'value' in value && !isEmptyValue((value as RuleParameterOption).value)
  );
}

export function getUnresolvedDropdownFields(fields: RuleParameterField[], values: RuleParameterValues) {
  return fields.filter((field) => {
    if (!isDropdownField(field)) return false;
    const value = values[field.id];
    return !isEmptyValue(value) && !isResolvedOption(value);
  });
}

export function serializeRuleParameterValues(fields: RuleParameterField[], values: RuleParameterValues) {
  const orderedValues = fields.map((field) => values[field.id]);

  return {
    ruleTypeParams: orderedValues
      .map((value) => {
        if (!value || typeof value !== 'object') return value ?? '';
        const option = value as RuleParameterOption;
        return option.persistentName || option.label || '';
      })
      .join(','),
    ruleTypeParamsId: orderedValues
      .map((value, index) => {
        if (!isResolvedOption(value)) return null;
        const persistentName = value.persistentName || value.label || fields[index].id;
        return `${persistentName}=${value.value}`;
      })
      .filter(Boolean)
      .join(','),
  };
}
